"use strict";

export default angular.module("contartemx.bancos.cuentas_bancarias", [
	'contartemx',
	'ui.router',
	'ngTable',
	'ui.bootstrap',
	'datePicker',
	"tableTools",
	"loader",
])

.controller("CuentasBancariasCtrl", function CuentasBancariasController($scope, $state, $stateParams, NgTableParams, $filter, $http, $uibModal,dateTools, callToWebService,mostrarNotificacion) {

	$scope.selectedOpt = 0;
	$scope.DisRes = true;
	$scope.DisRes = true;
    $scope.fechas = [
        { id: 2, name: 'Mes Actual' },
        { id: 3, name: 'Mes Pasado' },
        { id: 9, name: 'Hasta hoy' },
        { id: 10, name: 'Actual trimestre' },
        { id: 5, name: 'Este a\u00f1o' },
        { id: 8, name: 'Fechas Especificas' }];
    $scope.filtroFechaDispo = 2;
    $scope.filtroFechaAdeud = 2;
    $scope.estadoCuentaSelected = 1;
    $scope.filtro = {
        EstadoCuenta: $scope.estadoCuentaSelected,
        FiltroFecha: 2,
        TipoDeSaldo: 1
    };
	$scope.llamadoInicial = 1;

	$scope.$watch('llamadoInicial', function () {
		$scope.loading = true;
		callToWebService.postCall('ObtenerPantallaListadoCuentasBancarias', { filtro: $scope.filtro},
		function sucess(data){
			//Modal
			if(data.CodigoRespuesta == 200){
				$scope.ListaBancos = data.Respuesta.ProveedoresBancarios;
				$scope.TipoCuentas = data.Respuesta.TiposDeBanco;
				$scope.CatalogoBancosSat = data.Respuesta.CatalogoBancosSAT;
				$scope.Monedas = data.Respuesta.Monedas;
				$scope.cuentas = data.Respuesta.Cuentas;
				//Main
				$scope.SaldoNegativo = data.Respuesta.SaldoNegativo;
				$scope.SaldoPositivo = data.Respuesta.SaldoPositivo;
				$scope.Disponibles = data.Respuesta.CuentasPositivas;
				$scope.Adeudos = data.Respuesta.CuentasNegativas;
				$scope.DisRes = $scope.Disponibles.length > 0;
				$scope.AdeRes = $scope.Adeudos.length > 0;
				$scope.noTieneResultados = data.Respuesta.NoTieneResultados;
			}else{
				mostrarNotificacion.error(data.Mensaje);
			}
			$scope.loading = false;
		},
		function error(data){
			mostrarNotificacion.error(data.Mensaje);
			$scope.loading = false;
		});
    }, true);	

    $scope.estadoCta = "Activas";
	$scope.MostrarActivas = true;
	$scope.MostrarDesactivadas = false;

	$scope.estadoCuentasBancarias = function(i){
		$scope.selectedOpt = i;
		$scope.estadoCuentaSelected = i;
		switch (i) {
			case 0:
				$scope.estadoCta = "Activas";
				$scope.MostrarActivas = true;
				$scope.MostrarDesactivadas = false;
				break;
			case 1:
				$scope.estadoCta = "Desactivadas";
				$scope.MostrarActivas = false;
				$scope.MostrarDesactivadas = true;
				break;
		}
	};
	$scope.mostrarFechasFiltroDisponible = false;
	$scope.mostrarFechasFiltroAdeudo = false;

	$scope.$watch('Disponibles', function (params,paramsOld) {
		if(params != paramsOld){
			for(var i in $scope.Disponibles){
				if($scope.Disponibles[i].NumeroDeCuentaTexto)
				{
					var clv = $scope.Disponibles[i].NumeroDeCuentaTexto;
					if(clv.length > 4)
						$scope.Disponibles[i].NumeroDeCuenta = clv.substr(clv.length-4);
					else
						$scope.Disponibles[i].NumeroDeCuenta = clv;				
				}
			}
		}
    }, true);

    $scope.$watch('Adeudos', function (params,paramsOld) {
		if(params != paramsOld){
			for(var i in $scope.Adeudos){
				if($scope.Adeudos[i].NumeroDeCuentaTexto)
				{
					var clv = $scope.Adeudos[i].NumeroDeCuentaTexto;
					if(clv.length > 4)
						$scope.Adeudos[i].NumeroDeCuenta = clv.substr(clv.length-4);
					else
						$scope.Adeudos[i].NumeroDeCuenta = clv;
				}
			}
		}
    }, true);

	$scope.$watch('filtroFechaDispo', function (params,paramsOld) {
		if(params == 8){
			$scope.mostrarFechasFiltroDisponible = true;
		}else{
			$scope.mostrarFechasFiltroDisponible = false;
			$scope.loading = true;	

		if(params != paramsOld){
			$scope.filtro = {
			    EstadoCuenta: $scope.estadoCuentaSelected,
			    FiltroFecha:params,
			    TipoDeSaldo:2
			};
			callToWebService.postCall('ObtenerPantallaListadoCuentasBancarias', { filtro: $scope.filtro},
			  function sucess(data){
			  	$scope.Disponibles = data.Respuesta.CuentasPositivas;
			  	$scope.DisRes = $scope.Disponibles.length > 0;
			  	$scope.loading = false;		
			  	$scope.noTieneResultados = data.Respuesta.NoTieneResultados;	  	
			  },
			  function error(data){
			  	$scope.loading = false;
			  });
		}
			
		}
    }, true);

	$scope.$watch('filtroFechaAdeud', function (params,paramsOld) {		if(params == 8){
			$scope.mostrarFechasFiltroAdeudo = true;
		}else{
			$scope.mostrarFechasFiltroAdeudo = false;
			$scope.loading = true;	

		if(params != paramsOld){
			$scope.filtro = {
			    EstadoCuenta: $scope.estadoCuentaSelected,
			    FiltroFecha:params,
			    TipoDeSaldo:0
			};
		callToWebService.postCall('ObtenerPantallaListadoCuentasBancarias', { filtro: $scope.filtro},
		  function sucess(data){
		  	$scope.Adeudos = data.Respuesta.CuentasNegativas;
		  	$scope.AdeRes = $scope.Adeudos.length > 0;	
		  	$scope.loading = false;		
		  	$scope.noTieneResultados = data.Respuesta.NoTieneResultados;  	
		  },
		  function error(data){
		  	$scope.loading = false;
		  });
		}
		
		}
    }, true);

    $scope.llamarBancosDisponiblesFechas = function(){
		var fechaIniDisponible = $('#fechaInicialDisponible').val();
		var fechaFinDisponible = $('#fechaFinalDisponible').val();
		if(fechaIniDisponible != "" && fechaFinDisponible != ""){
			if($scope.Movil)
		        var fechaIniDisponible = dateTools.getTimeForWCF(fechaIniDisponible,'YYYY-MM-DD');
		    else
		        var fechaIniDisponible = dateTools.getTimeForWCF(fechaIniDisponible,'DD/MM/YY');

		    if($scope.Movil)
		        var fechaFinDisponible = dateTools.getTimeForWCF(fechaFinDisponible,'YYYY-MM-DD');
		    else
		        var fechaFinDisponible = dateTools.getTimeForWCF(fechaFinDisponible,'DD/MM/YY');

			$scope.filtro = {
			    EstadoCuenta: $scope.estadoCuentaSelected,
			    FiltroFecha:8,
			    TipoDeSaldo:1,
			    FechaInicial:fechaIniDisponible,
			    FechaFinal:fechaFinDisponible
			};
			$scope.loading = true;
			callToWebService.postCall('ObtenerPantallaListadoCuentasBancarias', { filtro: $scope.filtro},
			  function sucess(data){
			  	$scope.Disponibles = data.Respuesta.CuentasPositivas;
			  	$scope.DisRes = $scope.Disponibles.length > 0;
			  	$scope.Adeudos = data.Respuesta.CuentasNegativas;
			  	$scope.AdeRes = $scope.Adeudos.length > 0;		
			  	$scope.loading = false;
			  	$scope.noTieneResultados = data.Respuesta.NoTieneResultados;
			  },
			  function error(data){
			  	$scope.loading = false;
			  });
		}else{
			mostrarNotificacion.error("Es necesario seleccionar fecha inicial y final.");	
		}
    };

    $scope.llamarBancosAdeudosFechas = function(){
		var fechaIniAdeudo = $('#fechaInicialAdeudo').val();
		var fechaFinAdeudo = $('#fechaFinalAdeudo').val();
		if(fechaIniAdeudo != "" && fechaFinAdeudo != ""){
			if($scope.Movil)
		        var fechaIniAdeudo = dateTools.getTimeForWCF(fechaIniAdeudo,'YYYY-MM-DD');
		    else
		        var fechaIniAdeudo = dateTools.getTimeForWCF(fechaIniAdeudo,'DD/MM/YY');

		    if($scope.Movil)
		        var fechaFinAdeudo = dateTools.getTimeForWCF(fechaFinAdeudo,'YYYY-MM-DD');
		    else
		        var fechaFinAdeudo = dateTools.getTimeForWCF(fechaFinAdeudo,'DD/MM/YY');

			$scope.filtro = {
			    EstadoCuenta: $scope.estadoCuentaSelected,
			    FiltroFecha:8,
			    TipoDeSaldo:1,
			    FechaInicial:fechaIniAdeudo,
			    FechaFinal:fechaFinAdeudo
			};
			$scope.loading = true;
			callToWebService.postCall('ObtenerPantallaListadoCuentasBancarias', { filtro: $scope.filtro},
			  function sucess(data){
			  	$scope.Disponibles = data.Respuesta.CuentasPositivas;
			  	$scope.DisRes = $scope.Disponibles.length > 0;
			  	$scope.Adeudos = data.Respuesta.CuentasNegativas;
			  	$scope.AdeRes = $scope.Adeudos.length > 0;		
			  	$scope.loading = false;
			  	$scope.noTieneResultados = data.Respuesta.NoTieneResultados;
			  },
			  function error(data){
			  	$scope.loading = false;
			  });
		}else{
			mostrarNotificacion.error("Es necesario seleccionar fecha inicial y final.");	
		}
    };

	$scope.DisRes = true;
	$scope.AdeRes = true;
    $scope.$watch('selectedOpt', function (params,paramsOld) {
		$scope.mostrarFechasFiltroDisponible = false;
		$scope.mostrarFechasFiltroAdeudo = false;
		$scope.filtroFechaDispo = 2;
		$scope.filtroFechaAdeud = 2;
		if(params != paramsOld){
			if(params == 0)
				$scope.EstadoCuentaWeb = 1;
			else
				$scope.EstadoCuentaWeb = 2;
			$scope.filtro = {
			    EstadoCuenta:$scope.EstadoCuentaWeb,
			    FiltroFecha:9,
			    TipoDeSaldo:1
			};
			$scope.loading = true;
			callToWebService.postCall('ObtenerPantallaListadoCuentasBancarias', { filtro: $scope.filtro},
			  function sucess(data){
			  	$scope.Disponibles = data.Respuesta.CuentasPositivas;
			  	$scope.DisRes = $scope.Disponibles.length > 0;
			  	$scope.Adeudos = data.Respuesta.CuentasNegativas;
			  	$scope.AdeRes = $scope.Adeudos.length > 0;		
			  	$scope.loading = false;	  	
			  	$scope.noTieneResultados = data.Respuesta.NoTieneResultados;
			  },
			  function error(data){
			  	$scope.loading = false;
			  });
		}
    }, true);

    $scope.tableParams = new NgTableParams({
		page: 1
	});
	$scope.$watch("tableParams", function (params, paramsOld) {
		if($scope.Disponibles){
			var orderedData = $scope.Disponibles.reverse();
			$scope.Disponibles = orderedData;
		}
	}, true);

	$scope.tableParamsAdeudo = new NgTableParams({
		page: 1
	});
	$scope.$watch("tableParamsAdeudo", function (params, paramsOld) {
		if($scope.Adeudos){
			var orderedData = $scope.Adeudos.reverse();
			$scope.Adeudos = orderedData;
		}
	}, true);
	
	$scope.desactivarBancoOption = function(esDisponible){
		
		var selRow = $(".listTable--bancos tr.listTableRow--selected");

		if(esDisponible)
			{
				var cveTransaccion = $scope.Disponibles[$scope.selectedRow].CveCuentaBanco;
				for(var n = 0; n < $scope.Disponibles.length ;n++){
					$(".popover--cancelBancos[CveTransaccion='" + $scope.Disponibles[n].CveCuentaBanco + "']").addClass("popover--hidden");
				}
			}else{
				var cveTransaccion = $scope.Adeudos[$scope.selectedRowAdeudo].CveCuentaBanco;
				for(var n = 0; n < $scope.Adeudos.length ;n++){
					$(".popover--cancelBancos[CveTransaccion='" + $scope.Adeudos[n].CveCuentaBanco + "']").addClass("popover--hidden");
				}
			}
			
			
		$(".popover--cancelBancos[CveTransaccion='" + cveTransaccion + "']").removeClass("popover--hidden");

		$("#contextmenu-disponible, #contextmenu-adeudo").removeClass("open");
		
	};

	$scope.desactivarBanco = function(cveCuentaBanco){
		$scope.loading = true;
		callToWebService.postCall('DesactivarBanco', { claveBanco: cveCuentaBanco},
		function sucess(data){
			if(data.CodigoRespuesta != 500){
				if(data.CodigoRespuesta == 300 && data.EsError){
					$scope.modalConfirmarDesactivar(cveCuentaBanco);
				}
				if(data.CodigoRespuesta == 200){
					$scope.llamadoInicial++;
				}
				mostrarNotificacion.info(data.Mensaje);
			}else{
				mostrarNotificacion.error(data.Mensaje);
			}
				$scope.loading = false;
		},
		function error(data){
			mostrarNotificacion.error(data.Mensaje);
			$scope.loading = false;
		});
	};

	$scope.reactivarBanco = function(cveCuentaBanco){
		$scope.loading = true;
		callToWebService.postCall('ReactivarBanco', { claveBanco: cveCuentaBanco},
		function sucess(data){

			if(data.CodigoRespuesta != 500)
			{
				mostrarNotificacion.info(data.Mensaje);
				$scope.llamadoInicial++;
			}else{
				mostrarNotificacion.error(data.Mensaje);
			}

			$scope.loading = false;
		},
		function error(data){
			$scope.loading = false;
		});
	};


	$scope.modalConfirmarDesactivar = function(cveCuentaBanco){
		var modalInstance = $uibModal.open({
            template: require('../../../../../app/views/Bancos/Cuentas_Bancarias/DesactivarConfirmar_modal.html'),
            controller: modalDesactivarCuentaCtrl,
            windowClass: 'modal--small',
            resolve:{
            	cveCuentaBanco: function () {
					return cveCuentaBanco;
				}
            }
        });
        modalInstance.result.then(function (data) {
        	mostrarNotificacion.info(data.Mensaje);
			$scope.llamadoInicial++;
		});
	};

    var modalDesactivarCuentaCtrl = function ($scope, $uibModalInstance, cveCuentaBanco) {
    	$scope.confirmarDesactivacion = function(){
			callToWebService.postCall('DesactivarBanco', { claveBanco: cveCuentaBanco, ignorarConfirm: true},
			function sucess(data){
				
				 $uibModalInstance.close(data);
			},
			function error(data){
				
			});
    	};

		$scope.closeModal = function (respuesta) {
			$uibModalInstance.dismiss();
		};
    };

    $scope.modalCuentasBancarias = function (isNew, cveCuenta) {
        $scope.loading = true;
        $scope.$emit('nextOnboardingStep', 'bancos.modal.nuevaCuenta');

        var seAgregoBanco = false;

		var modalInstance = $uibModal.open({
            template: require('../../../../../app/views/Bancos/Cuentas_Bancarias/CuentaBancaria_modal.html'),
            controller: modalCuentasBancariasCtrl,
          windowClass: 'modal--small',
          openedClass: 'overflow-y-hidden',
          appendTo: angular.element(document.querySelector('.modal-parent')),
            resolve:{
            	listaBancos: function () {
					return $scope.ListaBancos;
				},
				tiposCuentas: function () {
					return $scope.TipoCuentas;
				},
				monedas: function () {
					return $scope.Monedas;
				},
				esMovil: function () {
					return $scope.Movil;
				},
				cuenta: function(){
					return isNew;
				},
				claveBancoModal: function(){
					if(isNew){
						return null;
					}else{
						return cveCuenta;
					}
				},
				catalogoBancosSat: function(){
					return $scope.CatalogoBancosSat;
				}
            }
		});

        modalInstance.result.then(function (data) {
        	mostrarNotificacion.info(data.Mensaje);
        	$scope.llamadoInicial++;

        	if (data.CodigoRespuesta == 200 && !data.EsError) {
        	    $scope.$emit('nextOnboardingStep', 'last');
        	    seAgregoBanco = true;
        	}

        }).finally(() => {
            $scope.loading = false;
            $scope.$emit('nextOnboardingStep', seAgregoBanco ? 'last' : 'bancos.cuentasBancarias');
        });
	};

	$scope.modalSaldo = function(cuenta){
		var modalInstance = $uibModal.open({
            template: require('../../../../../app/views/Bancos/Cuentas_Bancarias/EditarSaldo_modal.html'),
            controller: modalSaldoCtrl,
          windowClass: 'modal--small',
          openedClass: 'overflow-y-hidden',
          appendTo: angular.element(document.querySelector('.modal-parent')),
            resolve:{
            	CuentaId: function () {
					return cuenta.CveCuentaBanco;
				},
				esMovil: function () {
					return $scope.Movil;
				}
            }
        });
        modalInstance.result.then(function (data) {
        	if(data.EsError){
        		mostrarNotificacion.error(data.Mensaje);	
        	}
        	else{
        		mostrarNotificacion.info("El saldo inical se actualizo correctamente");
				$scope.llamadoInicial++;
        	}
        	
		});
	};

	 var modalSaldoCtrl = function ($scope, $uibModalInstance, CuentaId, esMovil) {
	    
	    $scope.closeModal = function () {
			$uibModalInstance.dismiss();
		};

		callToWebService.postCall('ObtenerDatosBanco', {claveBanco: CuentaId},
        function sucess(data){
        	$scope.tipoCuenta = data.Respuesta.Tipo;
        	$scope.nombreCuenta = data.Respuesta.Nombre;
			$scope.saldo = data.Respuesta.Saldo;
			$scope.numeroCuenta = data.Respuesta.NumeroDeCuenta;
        	var obtenerFecha = data.Respuesta.FechaDeSaldoString;
        	if(esMovil)
    		{
    			$scope.transactionDate = obtenerFecha.substring(6,10)+"-"+obtenerFecha.substring(3,5)+"-"+obtenerFecha.substring(0,2);
    		}else{
    			$scope.transactionDate = obtenerFecha.substring(0,2)+"/"+obtenerFecha.substring(3,5)+"/"+obtenerFecha.substring(8,10);
    		}
        },
        function error(data){
        });
		$scope.saveChanges = function(f){
			var fecha;
			var saldo  = parseFloat(f.saldo.$viewValue);
			var fechaInput = $('#fechaSaldo').val();
			
			if(esMovil)
		        fecha = dateTools.getTimeForWCF(fechaInput,'YYYY-MM-DD');
		    else
		        fecha = dateTools.getTimeForWCF(fechaInput,'DD/MM/YY');

			var datosEnviar = {
				banco:{
					ClaveBanco : CuentaId,
					FechaDeSaldo: fecha,
					Saldo : saldo
				}
			};
	     	callToWebService.postCall("EditarSaldoInicial", datosEnviar,
	        function sucess(data){
	            if(data.EsError){
	            	$scope.alert = [];
					$scope.alert.push({
		              type: 'error',
		              msg: data.Mensaje
		            });
	            }
	            else{
	            	$uibModalInstance.close(data);
	            }
	        },
	        function error(data){
	        	
	            mostrarNotificacion.error(data.Mensaje);
	        });
		};
    };

    var modalCuentasBancariasCtrl = function ($scope, $uibModalInstance, listaBancos, tiposCuentas, monedas, esMovil, cuenta, claveBancoModal, catalogoBancosSat) {
    	if(esMovil)
	        $scope.transactionDate = moment().format('YYYY-MM-DD');
	    else
	        $scope.transactionDate = moment().format('DD/MM/YY');

	    $scope.closeModal = function (respuesta) {
			$uibModalInstance.dismiss();
		};
		
		if(cuenta){
			$scope.esNueva = 'Nueva ';
			$scope.esCuentaNueva = true;
		}else{
			$scope.esCuentaNueva = false;
			$scope.esNueva = 'Editar ';
		}
		$scope.Undefined = true;
		$scope.Monedas = monedas;
		$scope.moneda = 1;
		$scope.ListTipoCuentas = tiposCuentas;
		$scope.ListaBancos = listaBancos;
		$scope.CatalogoBancosSat = catalogoBancosSat;
		$scope.claveBancoSat = "999";
		$scope.$watch("tipoCuenta", function (params, paramsOld) {
			if(!angular.isUndefined(params)){
				if(params != paramsOld){
					if(params == 1010000){
						$scope.Undefined = true;
					}else{
						$scope.Undefined = false;
					}
				}
			}
		}, true);

		//editar banco
    	if(!cuenta)
    	{
    		//llamar ObtenerDatosBanco
    		callToWebService.postCall('ObtenerDatosBanco', {claveBanco: claveBancoModal},
	        function sucess(data){
	        	$scope.tipoCuenta = data.Respuesta.Tipo;
	        	$scope.ListaBancos.ClaveProveedor = data.Respuesta.ClaveProveedor ? data.Respuesta.ClaveProveedor : undefined;
	        	$scope.claveBancoSat = data.Respuesta.ClaveBancoSAT;

	        	if($scope.tipoCuenta == 1010000 && $scope.tipoCuenta > 1){
	                //es tipo caja
	                $scope.nombreCuenta = data.Respuesta.Nombre;
	            }
	            else if($scope.tipoCuenta != 1010000 && $scope.tipoCuenta > 1){
	                //es tipo banco
	                $scope.numeroCuenta = data.Respuesta.NumeroDeCuenta;
	                $scope.ListaBancos.ClaveProveedor = data.Respuesta;
	            }
	            $scope.moneda = data.Respuesta.ClaveMoneda;
	        	$scope.saldo = data.Respuesta.Saldo;
	        	if($scope.saldo > 0)
	        		$scope.mostrarFecha = true;
	        	var obtenerFecha = data.Respuesta.FechaDeSaldoString;
	        	if(esMovil)
        		{
        			$scope.transactionDate = obtenerFecha.substring(6,10)+"-"+obtenerFecha.substring(3,5)+"-"+obtenerFecha.substring(0,2);
        		}else{
        			$scope.transactionDate = obtenerFecha.substring(0,2)+"/"+obtenerFecha.substring(3,5)+"/"+obtenerFecha.substring(8,10);
        		}
	        },
	        function error(data){
	        });
    	}

		$scope.$watch("saldo", function (params) {
			if(!angular.isUndefined(params)){
				var num = parseFloat(params);
				if(num)
					$scope.mostrarFecha = true;
				else
					$scope.mostrarFecha = false;
			}
		}, true);

		$scope.$watch("ListaBancos.ClaveProveedor", function (params) {
			if(!angular.isUndefined(params))
				$scope.ClaveProveedor = params.ClaveProveedor;
		}, true);
		
		$scope.saveChanges = function(f){
			var fecha;
			var nombre;
			var numeroCuenta;
			var saldo;
			var fechaInput = $('#fechaSaldo').val();
			if($scope.mostrarFecha){
				if(esMovil)
			        fecha = dateTools.getTimeForWCF(fechaInput,'YYYY-MM-DD');
			    else
			        fecha = dateTools.getTimeForWCF(fechaInput,'DD/MM/YY');
			}
			else{
				if(esMovil)
			        fecha = dateTools.getTimeForWCF(fechaInput,'YYYY-MM-DD');
			    else
			        fecha = dateTools.getTimeForWCF(fechaInput,'DD/MM/YY');
			}
			if($scope.Undefined){
				nombre = f.nombreCuenta.$viewValue;
				numeroCuenta = 0;
			}
			else{
				nombre = f.bancoSelect.$viewValue;
				numeroCuenta = f.numeroCuenta.$viewValue;
			}
			if(f.saldo.$viewValue)
				saldo = parseFloat(f.saldo.$viewValue);
			else
				saldo = 0;
			var llamadoEjecutar = '';
			var datosEnviar = null;
			if(cuenta){
				llamadoEjecutar = 'CrearBanco';
				var datosEnviar = {banco:{
					Nombre : nombre,
					ClaveMoneda: f.moneda.$viewValue,
					FechaDeSaldo: fecha,
					Tipo : f.tipoCuenta.$viewValue,
					Saldo : saldo,
					NumeroDeCuenta : numeroCuenta,
					ClaveProveedor : $scope.ClaveProveedor ? $scope.ClaveProveedor : null,
					ClaveBancoSAT : $scope.claveBancoSat
				}};
			}else{
				llamadoEjecutar = 'EditarBanco';
				var datosEnviar = {banco:{
					ClaveBanco : claveBancoModal,
					Nombre : nombre,
					ClaveMoneda: f.moneda.$viewValue,
					FechaDeSaldo: fecha,
					Tipo : f.tipoCuenta.$viewValue,
					Saldo : saldo,
					NumeroDeCuenta : numeroCuenta,
					ClaveProveedor : $scope.ClaveProveedor ? $scope.ClaveProveedor : null,
					ClaveBancoSAT : $scope.claveBancoSat
				}};
			}
	     	callToWebService.postCall(llamadoEjecutar, datosEnviar,
	        function sucess(data) {
	            $scope.$emit('nextStepOnboarding', 'last');
	            $uibModalInstance.close(data);
	        },
	        function error(data){
	            mostrarNotificacion.error(data.Mensaje);
	        });
		};
    };

	$scope.select = function (index, estaActivo) {
		$scope.selectedRow = index;
		if(estaActivo)
			{
				$scope.esBancoActivo = true;
			}else{
				$scope.esBancoActivo = false;
			}
	};

	$scope.deselect = function () {
		$scope.selectedRow = -1;
		$scope.selectedRowAdeudo = -1;
	}

	$scope.selectAdeudo = function (index, estaActivo) {
		
		$scope.selectedRowAdeudo = index;
		if(estaActivo)
			{
				$scope.esBancoActivo = true;
			}else{
				$scope.esBancoActivo = false;
			}
	}

	$scope.deselectAdeudo = function () {
		$scope.selectedRow = -1;
		$scope.selectedRowAdeudo = -1;
	}

	$scope.deselectAdeudoTable = function()
	{
		var theads = document.getElementsByTagName('thead');
		theads[1].style.display = '';
		var actions = $('.actionsHeader#adeudo')[0]
		if (typeof actions !== "undefined") {
		actions.style.display = 'none';
		}
		$scope.selectedRowAdeudo = -1;

		var menu = document.getElementById('contextmenu-adeudo');
		menu.style.display = 'none';
	}

	$scope.deselectDisponibleTable = function()
	{
		var theads = document.getElementsByTagName('thead');
		theads[0].style.display = '';
		var actions = $('.actionsHeader#disponible')[0]
		if (typeof actions !== "undefined") {
		actions.style.display = 'none';
		}
		$scope.selectedRow = -1;

		var menu = document.getElementById('contextmenu-disponible');
		menu.style.display = 'none';
	}

	$scope.headerAction = function (index, cuenta, rowIndex) {
		if(cuenta)
		{
			switch (index) {
				case 0:
					break;

				case 1:
					break;
					
				case 2:
					
					$("#contextmenu-disponible, #contextmenu-adeudo").removeClass("open");
					$scope.rowIndexDisponible = rowIndex;
					$scope.modalCuentasBancarias(false, cuenta);	
					break;
				case 3:
					$("#contextmenu-disponible, #contextmenu-adeudo").removeClass("open");
					$scope.modalSaldo(cuenta);	
					break;

				default:
					return;
			}
		}
	};

    $scope.popupTraspasos = function () {
               var modalInstance = $uibModal.open({
            template: require('../../../../../app/views/Bancos/Traspasos/Traspasos_modal.html'),
            controller: TraspasosModalCtrl,
                 windowClass: 'modal--small',
                 openedClass: 'overflow-y-hidden',
                 appendTo: angular.element(document.querySelector('.modal-parent')),
            resolve:{
                cuentas: function(){
                    return $scope.cuentas;
                },
                monedas: function(){
                    return $scope.Monedas;
                },
                esMovil: function () {
                    return $scope.Movil;
                },
                indice: function(){
                	if($scope.selectedRowAdeudo != -1)
                		return $scope.Adeudos[$scope.selectedRowAdeudo].CveCuentaBanco;
                	else if($scope.selectedRow != -1)
                		return $scope.Disponibles[$scope.selectedRow].CveCuentaBanco;
                	else
                		return null;
                }
            }
        });
               modalInstance.result.then(function (data) {
                 if (data) {
                   mostrarNotificacion.info(data.Mensaje);
                   $scope.llamadoInicial++;
                 }  
        });
    };

        var TraspasosModalCtrl = function ($scope, $uibModalInstance, callToWebService, cuentas, monedas, esMovil, indice) {
        if (indice) {
        	$scope.valOrigen = indice;
        }

         $scope.cuentasTraspaso = cuentas;
        for(var i in $scope.cuentasTraspaso){
            var clv = $scope.cuentasTraspaso[i].NumeroDeCuenta.toString();
            if(clv != 0 && clv.length > 3)
                $scope.cuentasTraspaso[i].NumeroDeCuenta = clv.substr(clv.length-4);
            else 
                $scope.cuentasTraspaso[i].NumeroDeCuenta = clv;
        }
        if(esMovil)
        {
            $scope.Movil = true;
            $scope.fechaTraspaso = moment().format('YYYY-MM-DD');
        }else{
            $scope.Movil = false;
            $scope.fechaTraspaso = moment().format('DD/MM/YY');
        }
        $scope.monedasTraspaso = monedas;

        $scope.monedaActual = {};
        $scope.monedaActual.Codigo = 'MXN';
        $scope.monedaActual.CveMoneda = 1;
        $scope.$watch('monedaActual', function (moneda) {
            var cve = $scope.monedaActual.CveMoneda;
            for (var n = 0; n < $scope.monedasTraspaso.length; n++) {
                if (cve == $scope.monedasTraspaso[n].CveMoneda) {
                    $scope.tipoDeCambioActivo = $scope.monedasTraspaso[n].Valor.toFixed(2);
                    $scope.cveMonedaTraspaso = $scope.monedasTraspaso[n].CveMoneda;
                }
            }
        });

        $scope.valDestino = '';
        $scope.closeModal = function () {
            $uibModalInstance.close(null);
        };

        $scope.closeModalAlert = function (i) {
            $scope.alert.splice(i, 1);
        };

        $scope.cuentaDestino = function(nom){
            $scope.valDestino = nom;
        };

        $scope.cuentaOrigen = function(nom){
            $scope.valOrigen = nom;
        };
        $scope.invertirOrigen = function(){
            var origenSelected = $scope.valOrigen;
            var destinoSelected = $scope.valDestino;
            $scope.valOrigen = destinoSelected;
            $scope.valDestino = origenSelected;

        };
        $scope.importeDestino = false; 
        $scope.importeOrigenCodigo = "";
        $scope.importeDestinoCodigo = "";

        $scope.sonMonedasIguales = true;
        $scope.$watch('valOrigen', function (params, paramsOld) {
            if(params != "")
            {
                for(var x = 0;x < $scope.cuentasTraspaso.length;x++){
                    if(params == $scope.cuentasTraspaso[x].CveCuentaDeBanco){
                        for(var m = 0 ; m<monedas.length ; m++){
                            if($scope.cuentasTraspaso[x].CveMoneda == monedas[m].CveMoneda){
                                $scope.importeOrigenCodigo = monedas[m].Codigo;
                            }
                                

                        }

                    }
                }
                if($scope.importeOrigenCodigo != $scope.importeDestinoCodigo){
                    if($scope.valOrigen == "" || $scope.valDestino ==""){
                        $scope.sonMonedasIguales = true;
                    }else{
                        $scope.sonMonedasIguales = false;
                    }
                }else{

                    $scope.sonMonedasIguales = true;
                }
            }else{
                $scope.importeOrigenCodigo = "";
                $scope.sonMonedasIguales = true;
            }
            if( params == undefined)
            {
                $scope.sonMonedasIguales = true;
            }

            
        });
        $scope.$watch('valDestino', function (params, paramsOld) {
            if(params != "")
            {
                for(var x = 0;x < $scope.cuentasTraspaso.length;x++){
                    if(params == $scope.cuentasTraspaso[x].CveCuentaDeBanco){
                        for(var m = 0 ; m<monedas.length ; m++){
                            if($scope.cuentasTraspaso[x].CveMoneda == monedas[m].CveMoneda){
                                $scope.importeDestinoCodigo = monedas[m].Codigo;
                            }
                                
                        }

                    }
                }
                if($scope.importeOrigenCodigo != $scope.importeDestinoCodigo){
                    if($scope.valOrigen == "" || $scope.valDestino ==""){
                        $scope.sonMonedasIguales = true;
                    }else{
                        $scope.sonMonedasIguales = false;
                    }
                }else{
                    $scope.sonMonedasIguales = true;
                }
            }else{
                $scope.importeDestinoCodigo = "";
                $scope.sonMonedasIguales = true;

            }
            if( params == undefined)
            {
                $scope.sonMonedasIguales = true;
            }


        });

        $scope.guardarTraspaso = function(form){
            var monedaTipoCambioValidos = false;
            if(form.$valid){
                var ctaOrigen = form.cuentaOrigen.$viewValue ? form.cuentaOrigen.$viewValue : null;
                var ctaDestino = form.cuentaDestino.$viewValue ? form.cuentaDestino.$viewValue : null;
                var importeTraspaso = form.importe.$viewValue ? form.importe.$viewValue : null;
                var importeDestinoValue = form.importeDestinoValue.$viewValue ? form.importeDestinoValue.$viewValue : null;
                if($scope.sonMonedasIguales)
                {
                    importeDestinoValue = importeTraspaso;
                }
                var fechaTraspaso = $('#fechaTraspaso').val();
                var descripcionTraspaso = form.descripcion.$viewValue ? form.descripcion.$viewValue : null;
                var fecha;

                if(ctaOrigen && ctaDestino && importeTraspaso && importeDestinoValue && fechaTraspaso){
        
                    if(ctaOrigen != ctaDestino){
                        if(esMovil)
                        fecha = dateTools.getTimeForWCF(fechaTraspaso,'YYYY-MM-DD');
                    else
                        fecha = dateTools.getTimeForWCF(fechaTraspaso,'DD/MM/YY');
                    var generarTraspaso = {
                        ClaveCuentaOrigen:ctaOrigen,
                        ClaveCuentaDestino:ctaDestino,
                        MontoOrigen:importeTraspaso,
                        MontoDestino:importeDestinoValue,
                        Fecha:fecha,
                        Descripcion:descripcionTraspaso
                    };
                    callToWebService.postCall('GenerarTraspaso', { traspaso: generarTraspaso},
                    function sucess(data){
                        if(data.CodigoRespuesta == 200){
                            $uibModalInstance.close(data);
                        }else{
                            $scope.alert = [];
                            $scope.alert.push({ type: 'error', msg: data.Mensaje});
                        }
                        
                    },
                    function error(data){
                       $scope.alert = [];
                       $scope.alert.push({ type: 'error', msg: data.Mensaje});
                    });
                    }else{
                        $scope.alert = [];
                        $scope.alert.push({ type: 'error', msg: 'La cuentas Origen y Destino deben ser distintas.'});
                    }
                    
                }else{
                $scope.alert = [];
                $scope.alert.push({ type: 'error', msg: 'Faltan datos, ingresa los datos donde aparece el símbolo verde.'});
            
                }
            }
            else{
                $scope.alert = [];
                $scope.alert.push({ type: 'error', msg: 'Faltan datos, ingresa los datos donde aparece el símbolo verde.'});
            }
        };
   

      
    };
});
